import React from 'react';
import { Outlet } from 'react-router-dom';
import { ClientProfileProvider } from './context/ClientProfileContext';
import { VendrProductsProvider } from './context/VendrProductsContext';
import { AmazonBrandRegistryProvider } from './context/AmazonBrandRegistryContext';
import { AmazonProductsProvider } from './context/AmazonProductsContext';

export default function VendrProviders() {
  return (
    <ClientProfileProvider>
      <VendrProductsProvider>
        <AmazonBrandRegistryProvider>
          <AmazonProductsProvider>
            <Outlet />
          </AmazonProductsProvider>
        </AmazonBrandRegistryProvider>
      </VendrProductsProvider>
    </ClientProfileProvider>
  );
}
